import _ from "lodash";
import React, {useState} from "react";
import {BEANTRAGT} from "../../../consts/freigabestatus";
import {FACHADMIN, SYSTEMADMIN, ZUST_SBD} from "../../../consts/funktionaleRollen";
import {statusOptionen} from "../../../consts/valueLists";
import {handleApiException, useHttp} from "../../../services/HttpService";
import {getOrganisationenEndpoint} from "../../../services/OrganisationsService";
import {getBImSchVEndpoint, getBvtBrefEndpoint, getHaupttaetigkeitEndpoint, getNaceCodeEndpoint, getPrtrVoEndpoint, getTaetigkeitEndpoint} from "../../../services/WertelistenService";
import {userHasAnyRole} from "../../../utils/SecurityUtils";
import EAButton from "../../EAButton";
import EACombobox from "../../EACombobox";
import EADialog from "../../EADialog";
import {logger} from "../../../services/LogService";
import {LageVerortung} from "../common/LageVerortung";
import EARadioGroup from "../../EARadioGroup";
import {getIsBetreiberAbwsserbeseitigungspflichtigerInAnlageEndpoint} from "../../../services/BetriebeService";
import CircularProgress from "@material-ui/core/CircularProgress";
import {useHttpSortById} from "../../../utils/usePreformattedHttp";

function Betriebsdaten(props) {
    const [dlgBetreiberOpen, setDlgBetreiberOpen] = useState(false);
    const [tmpBetreiber, setTmpBetreiber] = useState(null);
    const [tmpBetreiberIsAbwasserbeseitigungspflichtiger, setTmpBetreiberIsAbwasserbeseitigungspflichtiger] = useState(null);
    const [changeBetreiberErros, setChangeBetreiberErrors] = useState({});
    const [haupttaetigkeitOptionen] = useHttpSortById(getHaupttaetigkeitEndpoint);
    const [betreiberOptionen] = useHttpSortById(getOrganisationenEndpoint);
    const [nacecodeOptionen] = useHttp(getNaceCodeEndpoint);
    const [taetigkeitOptionen] = useHttpSortById(getTaetigkeitEndpoint);
    const [bImSchVOptionen] = useHttpSortById(getBImSchVEndpoint);
    const [bvtBrefOptionen] = useHttpSortById(getBvtBrefEndpoint);
    const [prtrVoOptionen] = useHttpSortById(getPrtrVoEndpoint);
    const [
        betreiberAbwasserbeseitigungspflichtiger,
        checkBetreiberAbwasserbeseitigungspflichtiger,
    ] = useHttp(getIsBetreiberAbwsserbeseitigungspflichtigerInAnlageEndpoint(props.betriebsId), {manual: true});

    function handleClickBetreiberOpen() {
        if (props.betriebsId) {
            checkBetreiberAbwasserbeseitigungspflichtiger().catch((e) =>
                handleApiException(e, "Error checking if Betreiber is Abwasserbeseitigungspflichtiger for Anlage")
            );
        }

        setDlgBetreiberOpen(true);
    }

    function handleBetreiberClose() {
        setDlgBetreiberOpen(false);
    }

    function handleBetreiberChange(e, newValue) {
        setTmpBetreiber(newValue);
    }

    function handleBetreiberCloseOk() {
        const newErrors = {};
        if (!tmpBetreiber) {
            newErrors.betreiber = "Es muss ein neuer Betreiber angegeben werden!";
        }
        if (betreiberAbwasserbeseitigungspflichtiger.data && !tmpBetreiberIsAbwasserbeseitigungspflichtiger) {
            newErrors.abwasserbeseitigungspflichtiger =
                "Sie müssen angeben, ob der bisherige Betreiber als Abwasserbeseitigungspflichtiger für die entsprechenden Abwasseranlagen erhalten oder gelöscht werden soll!";
        }
        setChangeBetreiberErrors(newErrors);
        if (newErrors.betreiber || newErrors.abwasserbeseitigungspflichtiger) {
            return;
        }
        setDlgBetreiberOpen(false);
        const data = {...props.data};
        data.betreiber = {...tmpBetreiber};
        if (tmpBetreiberIsAbwasserbeseitigungspflichtiger) {
            data.preserveBetreiberAsAbwasserbeseitigungspflichtigen = tmpBetreiberIsAbwasserbeseitigungspflichtiger === "true";
        } else {
            data.preserveBetreiberAsAbwasserbeseitigungspflichtigen = false;
        }
        data.zustaendigePersonen = [];
        if (props.betriebsId) {
            data.betreiberAdresse = false;
        } else if (data.betreiberAdresse) {
            data.adresse = {...tmpBetreiber.adresse};
            data.bezeichnung = tmpBetreiber.bezeichnung;
        }

        logger.debug("BetreiberClose", data);
        props.onChangeWithValidate(data);
    }

    function isDisabled() {
        if (!props.betriebsId) return false;
        if (props.modus === "l") {
            return true;
        }
        if (props.modus === "s") {
            return !userHasAnyRole([ZUST_SBD, FACHADMIN, SYSTEMADMIN]);
        }
        return true;
    }

    function isLageVerortungDisabled() {
        if (!props.betriebsId) return false;
        if (props.modus === "s") {
            return !userHasAnyRole([ZUST_SBD, FACHADMIN, SYSTEMADMIN]);
        }
        return true;
    }

    return (
        <React.Fragment>
            <div className="gridl gridForBetriebsdaten tabsheet-content-margin">
                <div style={{gridColumnEnd: "span 7", gridRowEnd: "span 3"}}>
                    <div className="gridl" style={{gridTemplateColumns: "repeat(6,1fr)"}}>
                        {props.formFactory.renderInput(
                            "bezeichnung",
                            "bezeichnung",
                            "Bezeichnung",
                            "text",
                            props.data.betreiberAdresse || isDisabled(),
                            {style: {gridColumn: "span 6"}}
                        )}
                        {props.formFactory.renderInput(
                            "adresse.strasse",
                            "adresse.strasse",
                            "Strasse",
                            "text",
                            props.data.betreiberAdresse || isDisabled(),
                            {style: {gridColumn: "span 5"}}
                        )}
                        {props.formFactory.renderInput(
                            "adresse.hausnummer",
                            "adresse.hausnummer",
                            "Haus-Nr.",
                            "text",
                            props.data.betreiberAdresse || isDisabled()
                        )}
                        {props.formFactory.renderInput(
                            "adresse.plz",
                            "adresse.plz",
                            "PLZ",
                            "text",
                            props.data.betreiberAdresse || isDisabled()
                        )}
                        {props.formFactory.renderInput(
                            "adresse.ort",
                            "adresse.ort",
                            "Ort",
                            "text",
                            props.data.betreiberAdresse || isDisabled(),
                            {style: {gridColumn: "span 5"}}
                        )}
                    </div>
                </div>
                <div style={{gridColumnEnd: "span 7", gridRowEnd: "span 3"}}>
                    <div className="gridl" style={{gridTemplateColumns: "repeat(6,1fr)"}}>
                        {props.formFactory.renderInput("betreiber.bezeichnung", "betreiber.bezeichnung", "Betreiber", "text", true, {
                            style: {gridColumn: "span 6"},
                        })}
                        {props.formFactory.renderInput("betreiber.adresse.strasse", "betreiber.adresse.strasse", "Strasse", "text", true, {
                            style: {gridColumn: "span 5"},
                        })}
                        {props.formFactory.renderInput(
                            "betreiber.adresse.hausnummer",
                            "betreiber.adresse.hausnummer",
                            "Haus-Nr.",
                            "text",
                            true
                        )}
                        {props.formFactory.renderInput("betreiber.adresse.plz", "betreiber.adresse.plz", "PLZ", "text", true)}
                        {props.formFactory.renderInput("betreiber.adresse.ort", "betreiber.adresse.ort", "Ort", "text", true, {
                            style: {gridColumn: "span 5"},
                        })}
                    </div>
                </div>
                {props.formFactory.renderCheckbox(
                    "betreiberAdresse",
                    "betreiberAdresse",
                    "Betriebsadresse=Betreiber",
                    isDisabled(),
                    {
                        style: {gridColumnEnd: "span 11"},
                    },
                    [
                        createBetreiberAdresseDependentValue("bezeichnung", "betreiber.bezeichnung"),
                        createBetreiberAdresseDependentValue("adresse.strasse", "betreiber.adresse.strasse"),
                        createBetreiberAdresseDependentValue("adresse.hausnummer", "betreiber.adresse.hausnummer"),
                        createBetreiberAdresseDependentValue("adresse.plz", "betreiber.adresse.plz"),
                        createBetreiberAdresseDependentValue("adresse.ort", "betreiber.adresse.ort"),
                    ]
                )}
                {userHasAnyRole([ZUST_SBD, FACHADMIN, SYSTEMADMIN]) && (
                    <div style={{gridColumnEnd: "span 3", placeSelf: "end"}}>
                        {props.formFactory.renderButton(
                            "betreiberAendern",
                            "betreiberAendern",
                            "Betreiber ändern",
                            () => handleClickBetreiberOpen(),
                            {
                                "data-cy": "betreiberAendern",
                            }
                        )}
                    </div>
                )}
                <div style={{gridColumnEnd: "span 7"}}>
                    <LageVerortung
                        formFactory={props.formFactory}
                        data={props.data}
                        disabled={isLageVerortungDisabled()}
                        onClick={props.onChangeLage}
                        isButtonVisible={userHasAnyRole([ZUST_SBD, FACHADMIN, SYSTEMADMIN])}
                        modus={props.modus}
                    />
                </div>
                <div style={{marginTop: "var(--vertical-spacing)", gridColumn: "span 4"}}>
                    {props.formFactory.renderSelect(
                        "betriebsstatus",
                        "betriebsstatus",
                        "Status",
                        statusOptionen,
                        !props.betriebsId || props.data.freigabestatus === BEANTRAGT || isDisabled(),
                        {
                            optionTitle: "value",
                            optionKey: "id",
                        }
                    )}
                </div>
                {props.formFactory.renderInput("muttergesellschaft", "muttergesellschaft", "Muttergesellschaft", "text", isDisabled(), {
                    style: {gridColumnEnd: "span 4"},
                })}
                {props.formFactory.renderInput("url", "url", "Webadresse", "text", props.modus !== "s", {
                    style: {gridColumnEnd: "span 4"},
                })}
                <div style={{gridColumnEnd: "span 6", marginLeft: "var(--horizontal-spacing)"}}>
                    <div style={{display: "flex", gap: "8px", alignItems: "center"}}>
                        {props.formFactory.renderCheckbox("iedRelevanz", "iedRelevanz", "IED", isDisabled())}
                        {props.formFactory.renderCheckbox("prtrRelevanz", "prtrRelevanz", "PRTR", isDisabled())}
                    </div>
                </div>
                {props.formFactory.renderAutocompleteWerteliste(
                    "haupttaetigkeit",
                    "haupttaetigkeit",
                    "NACE-Tätigkeit",
                    haupttaetigkeitOptionen,
                    false,
                    isDisabled(),
                    {style: {gridColumnEnd: "span 5"}}
                )}
                {props.formFactory.renderAutocompleteWerteliste(
                    "nacecode",
                    "nacecode",
                    "NACE-Code",
                    nacecodeOptionen,
                    false,
                    isDisabled(),
                    {style: {gridColumnEnd: "span 9"}}
                )}
                {props.formFactory.renderAutocompleteWerteliste(
                    "bimschvs",
                    "bimschvs",
                    "Nr. 4.BImSchV",
                    bImSchVOptionen,
                    true,
                    isDisabled(),
                    {style: {gridColumnEnd: "span 14"}}
                )}
                {props.formFactory.renderAutocompleteWerteliste(
                    "taetigkeiten",
                    "taetigkeiten",
                    "Nr. IE-RL",
                    taetigkeitOptionen,
                    true,
                    isDisabled() || !props.data.iedRelevanz,
                    {style: {gridColumnEnd: "span 14"}}
                )}
                {props.formFactory.renderAutocompleteWerteliste(
                    "bvtBrefs",
                    "bvtBrefs",
                    "BvT / BREF",
                    bvtBrefOptionen,
                    true,
                    isDisabled(),
                    {style: {gridColumnEnd: "span 14"}}
                )}
                {props.formFactory.renderAutocompleteWerteliste(
                    "prtrVos",
                    "prtrVos",
                    "Nr. PRTR-VO",
                    prtrVoOptionen,
                    true,
                    isDisabled() || !props.data.prtrRelevanz,
                    {style: {gridColumnEnd: "span 14"}}
                )}
                <div style={{gridColumnEnd: "span 14", marginTop: "var(--vertical-spacing)", display: "flex", alignItems: "center", gap: "var(--horizontal-spacing)"}}>
                    {props.historieFeld && (
                        <div style={{flexShrink: 0, paddingLeft: "var(--horizontal-spacing)"}}>
                            {props.historieFeld}
                        </div>
                    )}
                    <div className="gridl" style={{gridTemplateColumns: "1fr 1fr 1fr 1fr 1.4fr", flex: 1}}>
                        {props.formFactory.renderInput("betriebsId", "betriebsId", "Betriebs-Nr.", "text", true)}
                        {props.formFactory.renderInput("betriebstyp.value", "betriebstyp.value", "Betriebstyp", "text", true)}
                        {props.formFactory.renderInput("katasterNr", "katasterNr", "Kataster-Nr.", "text", isDisabled())}
                        {props.formFactory.renderInput("arbeitsstaettenNr", "arbeitsstaettenNr", "Betriebsstätten-Nr.", "text", isDisabled())}
                        {props.formFactory.renderInput("localIdEuRegistry", "localIdEuRegistry", "Local ID for EU-Registry", "text", isDisabled())}
                    </div>
                </div>
            </div>
            <EADialog
                open={dlgBetreiberOpen}
                titleChildren={"Betreiber auswählen"}
                content={
                    betreiberAbwasserbeseitigungspflichtiger.loading ? (
                        <CircularProgress style={{margin: "auto", display: "block"}}/>
                    ) : (
                        <div className="gridl">
                            <p>
                                Das Ändern des Betreibers hat betriebsweite Auswirkungen.
                                <br/>
                                Nach dem Übernehmen werden alle zuständigen Personen gelöscht.
                            </p>
                            <EACombobox
                                style={{width: "500px"}}
                                id="autoBetreiber"
                                label="Betreiber"
                                options={betreiberOptionen.data && betreiberOptionen.data.length > 0 ? betreiberOptionen.data : []}
                                loading={betreiberOptionen.loading}
                                value={tmpBetreiber}
                                getOptionLabel={(option) =>
                                    option && option.bezeichnung
                                        ? option.bezeichnung +
                                        " - " +
                                        option.adresse.strasse +
                                        " " +
                                        option.adresse.hausnummer +
                                        " - " +
                                        option.adresse.plz +
                                        " " +
                                        option.adresse.ort
                                        : ""
                                }
                                error={changeBetreiberErros.betreiber}
                                onChange={handleBetreiberChange}
                            />
                            {betreiberAbwasserbeseitigungspflichtiger.data && (
                                <EARadioGroup
                                    label="bisherigen Betreiber als Abwasserbeseitigungspflichtigen"
                                    row
                                    options={[
                                        {title: "erhalten", value: "true"},
                                        {title: "löschen", value: "false"},
                                    ]}
                                    optionTitle="title"
                                    error={changeBetreiberErros.abwasserbeseitigungspflichtiger}
                                    optionKey="value"
                                    value={tmpBetreiberIsAbwasserbeseitigungspflichtiger}
                                    onChange={(e, nV) => {
                                        setTmpBetreiberIsAbwasserbeseitigungspflichtiger(nV);
                                    }}
                                />
                            )}
                        </div>
                    )
                }
                buttons={
                    <React.Fragment>
                        <EAButton id={"eins"} data-cy={"btnBetreiberAbbrechen"} label={"Abbrechen"} onClick={handleBetreiberClose}/>
                        <EAButton
                            id={"ok"}
                            data-cy={"btnBetreiberOk"}
                            label={"Übernehmen"}
                            color="primary"
                            onClick={handleBetreiberCloseOk}
                        />
                    </React.Fragment>
                }
                closeFunction={handleBetreiberClose}
            />
        </React.Fragment>
    );
}

function createBetreiberAdresseDependentValue(field, betreiberField) {
    return {
        id: field,
        calcDependentVal: (newVal, newState) => {
            if (newVal) {
                return _.get(newState, betreiberField);
            }
            return _.get(newState, field);
        },
    };
}

Betriebsdaten.propTypes = {
    //
};
export default Betriebsdaten;
